import { jsx as _jsx } from "react/jsx-runtime";
import { useSearchResultsIsSelectedFacet } from '@sitecore-search/react';
import { AccordionFacets } from '../../basePrimitives/index.js';
const FacetItem = (props) => {
    const { __scopeAccordionFacets } = props;
    const { facetId } = AccordionFacets.useAccordionFacetContext('AccordionFacet', __scopeAccordionFacets);
    const selected = useSearchResultsIsSelectedFacet(facetId, props.facetValueId);
    return _jsx(AccordionFacets.Item, { selected: selected, ...props });
};
export default FacetItem;
